import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import loadable from "@loadable/component";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./CarMoneyInfoBox.module.css";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { BottomSheet } from "@componentsShared/BottomSheet";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import useBoolean from "@hooks/useBoolean";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import EligibilityComponent from "@/_MiniApps/EligibilityComponent/EligibilityComponent";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import useIsMobile from "@hooks/useIsMobile";
import CarColorVariation from "@/pages/post/components/CarColorVariation/CarColorVariation";
import LimitedAvaInfoBox from "../LimitedAvaInfoBox/LimitedAvaInfoBox";
import SAR from "@componentsShared/SAR/SAR";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import { useLang } from "@/common/Contexts/LanguageContext";
import { TamaraWidget, useTamaraWidget } from "@hooks/useTamaraWidget";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { If } from "@componentsShared/Conditional/If";
import { Else } from "@componentsShared/Conditional/Else";
import { twMerge } from "tailwind-merge";
var fallback = {
  fallback: null
};
var PaymentTabBoxPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "PaymentTabBoxPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "PaymentTabBoxPopup" */"./PaymentTabBoxPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./PaymentTabBoxPopup");
    }
    return eval('require.resolve')("./PaymentTabBoxPopup");
  }
}, fallback);
var CallUsBy = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "CallUsBy";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "CallUsBy" */"./CallUsBy");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./CallUsBy");
    }
    return eval('require.resolve')("./CallUsBy");
  }
}, fallback);
var CarMoneyInfoBox = function CarMoneyInfoBox() {
  var _postDetails$details, _postDetails$details$, _postDetails$details2, _postDetails$details3, _postDetails$details4, _postDetails$details5, _postDetails$details6, _postDetails$details7, _postDetails$details8, _helpers$getCarPrice, _postDetails$details9, _postDetails$details0;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers,
    state = _usePostDetails.state,
    actions = _usePostDetails.actions,
    postDetails = _usePostDetails.postDetails,
    uiHelpers = _usePostDetails.uiHelpers;
  var desktop = !useIsMobile();
  var lang = useLang();
  var _useTamaraWidget = useTamaraWidget({
      type: "tamara-summary"
    }),
    ready = _useTamaraWidget.ready,
    loading = _useTamaraWidget.loading;
  //footer?.arboun
  var _useState = useState(false),
    showPaymentTabBoxPopup = _useState[0],
    setShowPaymentTabBoxPopup = _useState[1];
  var _useBoolean = useBoolean(),
    isCalculatorOpen = _useBoolean.value,
    openCalculator = _useBoolean.setTrue,
    closeCalculator = _useBoolean.setFalse,
    toggle = _useBoolean.toggle;
  var _useState2 = useState(false),
    hasInteracted = _useState2[0],
    setHasInteracted = _useState2[1];
  var fullScreen = useBoolean(false);
  var handleFirstInteraction = function handleFirstInteraction(_ref) {
    var field = _ref.field;
    if (hasInteracted) {
      var _helpers$getG4_data;
      setHasInteracted(false);
      trackEvents("finance_calculator_interact", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        post_trim: (_helpers$getG4_data = helpers.getG4_data()) === null || _helpers$getG4_data === void 0 ? void 0 : _helpers$getG4_data.post_ext,
        field_interaction: field
      }));
    }
  };
  useEffect(function () {
    if (isCalculatorOpen) {
      setHasInteracted(true);
      document.body.style.overflow = 'hidden';
    } else {
      setHasInteracted(false);
      document.body.style.overflow = '';
    }
  }, [isCalculatorOpen]);
  useEffect(function () {
    if (fullScreen.value) {
      setHasInteracted(true);
      document.body.style.overflow = 'hidden';
    } else {
      setHasInteracted(false);
      document.body.style.overflow = '';
    }
  }, [fullScreen.value]);
  var handleCalculatorClick = function handleCalculatorClick() {
    var _helpers$getG4_data2;
    openCalculator();
    trackEvents("finance_calculator_open", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
      post_trim: (_helpers$getG4_data2 = helpers.getG4_data()) === null || _helpers$getG4_data2 === void 0 ? void 0 : _helpers$getG4_data2.post_ext
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, helpers.isPreOwned() && /*#__PURE__*/React.createElement("p", {
    className: stl.preowned,
    id: "preowned-notice"
  }, /*#__PURE__*/React.createElement("img", {
    width: 16,
    height: 16,
    src: CDN_LINK + "/assets/images/gray-info-icon.svg",
    alt: "info",
    id: "preowned-notice-icon"
  }), /*#__PURE__*/React.createElement("span", {
    id: "preowned-notice-text"
  }, t("هذه سيارة جديدة تم إصدار لوحاتها مسبقا", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: [stl.newContainer],
    id: "car-money-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col",
    id: "price-boxes-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-stretch gap-0.5 flex-wrap",
    id: "price-boxes-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("border border-solid border-[#F7F8F9] rounded overflow-hidden flex-1", helpers.haveFinance() ? "w-[calc(50%-1px)]" : "w-full"),
    id: "cash-price-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-r-2 border-solid border-success py-1 px-1.5 h-full",
    id: "cash-price-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 pt-1 pb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-semibold text-neutral-100 text-xs",
    id: "cash-price-label"
  }, t("سعر الكاش", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-success leading-6",
    id: "cash-price-amount"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[24px] font-bold leading-6",
    id: "cash-price-value"
  }, helpers.getCarPrice().bestPrice), /*#__PURE__*/React.createElement("span", {
    className: "text-lg leading-4",
    id: "cash-price-currency"
  }, /*#__PURE__*/React.createElement(SAR, null))), helpers.hasDiscount() && /*#__PURE__*/React.createElement("div", {
    className: "text-gray-400 text-lg py-1 leading-3",
    id: "original-price-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold leading-3 text-xl"
  }, /*#__PURE__*/React.createElement("span", {
    className: "relative inline-block after:content-[''] after:absolute after:left-0 after:right-0 after:top-1/2 after:h-px after:bg-gray-500 after:-translate-y-1/2",
    id: "original-price-value"
  }, helpers.getCarPrice().fullPrice)), /*#__PURE__*/React.createElement("span", {
    className: "font-medium leading-3 text-lg",
    id: "original-price-currency"
  }, /*#__PURE__*/React.createElement(SAR, null))))), helpers.haveFinance() && /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-[#F7F8F9] rounded overflow-hidden flex-1 w-[calc(50%-1px)]",
    id: "finance-price-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-r-2 border-solid border-primary py-1 px-1.5 h-full",
    id: "finance-price-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: " pt-1 pb-2 text-xs font-semibold text-neutral-100",
    id: "finance-price-label"
  }, tShort("post_details/installment", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1",
    id: "finance-price-amount"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-primary leading-6"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[24px] leading-6 font-bold",
    id: "finance-monthly-price"
  }, helpers.getCarPrice().financeMonthlyPrice)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-px leading-4",
    id: "finance-price-unit"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-lg leading-4",
    id: "finance-currency"
  }, t("ريال", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm",
    id: "finance-period"
  }, t("شهرياً", {
    ns: "web_common"
  })))), helpers.haveFinance() && !helpers.isCarReserved() && /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-[#F7F8F9] rounded flex items-center justify-between my-1 p-1 cursor-pointer",
    onClick: function onClick() {
      return handleCalculatorClick();
    },
    id: "finance-calculator-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    width: 14,
    height: 14,
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/arithmetic.svg",
    alt: "arrow",
    id: "calculator-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-xs text-primary underline",
    id: "calculator-text"
  }, t("احسب التمويل", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--chevron-".concat(lang == "ar" ? "left" : "right", "-rounded"),
    width: 4,
    height: 4,
    className: "text-primary",
    id: "calculator-arrow"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between py-2",
    id: "price-info-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-[calc(50%-1px)] ",
    id: "vat-included-container"
  }, /*#__PURE__*/React.createElement("img", {
    width: 20,
    height: 20,
    src: CDN_LINK + "/assets/images/GreyCheck.svg",
    alt: "tik",
    id: "vat-check-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-[#697A8F] text-xss font-semibold",
    id: "vat-included-text"
  }, t("السعر يشمل الضريبة المضافة", {
    ns: "web_post_view"
  }))), helpers.isCashOnlyCar() && /*#__PURE__*/React.createElement("span", {
    className: "flex items-center w-[calc(50%-1px)] text-xss text-primary cursor-pointer underline",
    id: "how-to-buy-from-us",
    onClick: actions.openHowToBuyStory
  }, t("كيف تشتري سيارتك من سيارة؟", {
    ns: "web_post_view"
  }))), helpers.haveFinance() && showPaymentTabBoxPopup && /*#__PURE__*/React.createElement(PaymentTabBoxPopup, {
    onClose: function onClose() {
      return setShowPaymentTabBoxPopup(false);
    }
  }), desktop && helpers.isLimitedAvailability() && /*#__PURE__*/React.createElement("div", {
    className: ["mt-5"].join(" "),
    id: "limited-availability-container"
  }, /*#__PURE__*/React.createElement(LimitedAvaInfoBox, null)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-4",
    id: "color-variation-container"
  }, (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : (_postDetails$details$ = _postDetails$details.color_variants) === null || _postDetails$details$ === void 0 ? void 0 : _postDetails$details$.length) > 0 && /*#__PURE__*/React.createElement(CarColorVariation, {
    colors: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details2 = postDetails.details) === null || _postDetails$details2 === void 0 ? void 0 : _postDetails$details2.color_variants,
    currentColorCode: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details3 = postDetails.details) === null || _postDetails$details3 === void 0 ? void 0 : (_postDetails$details4 = _postDetails$details3.details_card) === null || _postDetails$details4 === void 0 ? void 0 : (_postDetails$details5 = _postDetails$details4.exterior_color) === null || _postDetails$details5 === void 0 ? void 0 : _postDetails$details5.code,
    currentColorName: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details6 = postDetails.details) === null || _postDetails$details6 === void 0 ? void 0 : (_postDetails$details7 = _postDetails$details6.details_card) === null || _postDetails$details7 === void 0 ? void 0 : (_postDetails$details8 = _postDetails$details7.exterior_color) === null || _postDetails$details8 === void 0 ? void 0 : _postDetails$details8.name
  })), !helpers.isCarReserved() && helpers.haveFinance() && /*#__PURE__*/React.createElement(EligibilityComponent, {
    design: "button",
    postID: helpers.getPostId(),
    postCondition: helpers.isCarUsed() ? "0" : "1",
    entryPoint: "car_details_page"
  }), helpers.isCarReserved() && desktop && /*#__PURE__*/React.createElement("div", {
    className: stl.reservedCarBox,
    id: "reserved-car-notice"
  }, /*#__PURE__*/React.createElement("strong", null, t("هذه السيارة محجوزة", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: twMerge("border-t border-solid border-neutral-10", helpers.hasTamara() && "border-0")
  }, /*#__PURE__*/React.createElement(If, {
    condition: helpers.hasTamara()
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-solid rounded-lg px-3 border-[#DFE4EE] mb-4",
    id: "tamara-widget-container"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: loading
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    className: "min-h-[46px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-3 pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-5 w-[60px] bg-gray-300 rounded"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-gray-300 animate-pulse h-5 rounded"
  }))))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    className: "min-h-[46px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-3 pb-3",
    onClick: function onClick() {
      trackEvents("tamara_widget_click", {
        referral_location: "car_detail"
      });
    },
    style: {
      display: ready ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement(TamaraWidget, {
    type: "tamara-summary",
    amount: ((_helpers$getCarPrice = helpers.getCarPrice()) === null || _helpers$getCarPrice === void 0 ? void 0 : _helpers$getCarPrice.bestPrice) || 0,
    "inline-type": "5",
    "inline-variant": "text",
    config: {
      "theme": "light",
      "badgePosition": "",
      "showExtraContent": "",
      "hidePayInX": false
    }
  }))))))), !helpers.isCarReserved() && /*#__PURE__*/React.createElement("a", {
    id: "BuyNow",
    className: ["greenBtn", stl.buyLinkPPt, "m-hide", "cursor-pointer"].join(" "),
    onClick: actions.navigateToLeadPage
  }, uiHelpers.getCTAGreenButtonText()), !state.showContactNumbers && !helpers.isCarReserved() && /*#__PURE__*/React.createElement("span", {
    className: ["greenTextBtn", stl.buyLinkPPt, "m-hide"].join(" "),
    onClick: actions.showContactNumbers,
    id: "call-us-button"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    className: "m-hide ".concat(stl.callGreen),
    src: CDN_LINK + "/assets/images/CallGreen.svg",
    alt: "call",
    width: 18,
    height: 18
  }), t("اتصل بنا للحجز", {
    ns: "web_post_view"
  }))), !state.showContactNumbers && helpers.isCarReserved() && /*#__PURE__*/React.createElement("span", {
    className: ["!m-0 greenTextBtn", stl.buyLinkPPt, "m-hide"].join(" "),
    onClick: actions.showContactNumbers,
    id: "contact-sales-button"
  }, t("تواصل مع مندوب المبيعات", {
    ns: "web_post_view"
  })), state.showContactNumbers && desktop && /*#__PURE__*/React.createElement(CallUsBy, null)), !helpers.isCarReserved() && (desktop ? /*#__PURE__*/React.createElement(BottomSheet, {
    open: isCalculatorOpen,
    onOpen: openCalculator,
    onClose: closeCalculator,
    maxHeight: "95%",
    maxHeightDesktop: "95%",
    hideTitleBar: true,
    screens: [{
      title: t('احسب قيمة التمويل', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
        carCondition: helpers.mapFinanceCalculatorCarCondition(),
        cashPrice: helpers.getCarPrice().numberPrice,
        onClose: closeCalculator,
        onInteraction: handleFirstInteraction,
        isPreowned: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details9 = postDetails.details) === null || _postDetails$details9 === void 0 ? void 0 : _postDetails$details9.is_preowned,
        postId: helpers.getPostId()
      })
    }, {
      title: t('شروط التمويل', {
        ns: "web_post_view"
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)
    }]
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: isCalculatorOpen,
    onOpenChange: toggle,
    repositionInputs: false,
    preventScrollRestoration: true
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "max-h-[110vh] z-[9999999]"
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    className: "bg-white p-0 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 py-4"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: "p-0 rounded-full bg-transparent outline-none border-none w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    className: "text-gray-text",
    height: 6,
    width: 6
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text font-bold w-full text-center"
  }, t('احسب قيمة التمويل', {
    ns: 'web_post_view'
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1 max-h-fit bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right space-y-4 text-[#333333]"
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
    carCondition: helpers.mapFinanceCalculatorCarCondition(),
    cashPrice: helpers.getCarPrice().numberPrice,
    onClose: closeCalculator,
    onInteraction: handleFirstInteraction,
    isPreowned: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details0 = postDetails.details) === null || _postDetails$details0 === void 0 ? void 0 : _postDetails$details0.is_preowned,
    postId: helpers.getPostId()
  })))))))));
};
export default CarMoneyInfoBox;